import { jsx as _jsx } from "react/jsx-runtime";
import Refresh from '@hellodarwin/icons/dist/icons/Refresh';
import Warning from '@hellodarwin/icons/dist/icons/Warning';
import { useTranslations } from '../../../features/providers/translations-provider';
import ErrorBox from '../error-box';
import { CrashScreenContainer } from './styles';
const CrashScreen = ({ onReset }) => {
    const { t } = useTranslations();
    return (_jsx(CrashScreenContainer, { children: _jsx(ErrorBox, { errorMessage: t('errorsPage|crashMessage'), ErrorIcon: Warning, CtaIcon: Refresh, ctaAction: onReset }) }));
};
export default CrashScreen;
